import { Transition } from '@uirouter/core';
import { ApiService } from "../utils/api.service";
import { LandingComponent } from './landing';
import { BusinessSelectComponent } from './business-select';
import { BusinessAddComponent } from './business-add';
import { SignUpPageWithBusinessComponent } from './signup-page';
import { ConnectComponent } from './connect';
import { LoginPageComponent } from './login-page';

export const LandingState = {
    name: 'ss_landing_state',
    url: '/squarespace/initiate?error&redirect_uri',
    component: LandingComponent,
    page: 'login',
    title: 'SquareSpace Connect',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.redirect_uri) {
                    params.redirect_uri = decodeURIComponent(decodeURIComponent(params.redirect_uri));
                }

                if (params.error) {
                    params.error = decodeURIComponent(params.error).replace(/\+/gi, ' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const ConnectState = {
    name: 'ss_connect_state',
    url: '/squarespace/connect?code&error&state',
    component: ConnectComponent,
    page: 'login',
    title: 'SquareSpace Connect',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.error) {
                    params.error = decodeURIComponent(params.error).replace(/\+/gi, ' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const BusinessSelectState = {
    name: 'ss_select_business',
    url: '/squarespace/initiate/select-business',
    component: BusinessSelectComponent,
    page: 'login',
    title: 'SquareSpace Connect',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };
                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const BusinessAddState = {
    name: 'ss_add_business',
    url: '/squarespace/initiate/add-business',
    component: BusinessAddComponent,
    page: 'login',
    title: 'SquareSpace Connect',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };
                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const SignUpState = {
    name: 'sign_up_ss',
    url: '/squarespace/sign_up?auth&error&oauth&client_id&client_secret&redirect_uri&response_type&page&promo',
    component: SignUpPageWithBusinessComponent,
    page: 'sign_up',
    title: 'Sign Up',
    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.redirect_uri) {
                    params.redirect_uri = decodeURIComponent(decodeURIComponent(params.redirect_uri));
                }

                if (params.error) {
                    params.error = decodeURIComponent(params.error).replace(/\+/gi, ' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};

export const LoginState = {
    name: 'login_ss',
    url: '/squarespace/login?promo&auth&error&username&access_token',
    component: LoginPageComponent,
    page: 'login',
    title: 'Sign In',

    resolve: [
        {
            token: 'params',
            deps: [Transition],
            resolveFn: function (Transition) {
                let params = { ...Transition.params() };

                if (params.username) {
                    params.username = decodeURIComponent(params.username);
                }

                if (params.error) {
                    params.error = decodeURIComponent(params.error).replace(/\+/gi, ' ');
                }

                return params;
            }
        },
        {
            token: 'config',
            deps: [ApiService],
            resolveFn: function (ApiService) {
                return ApiService.getConfig();
            }
        }
    ]
};